import { Loader } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { useHistory } from 'react-router';
import { ApplicationStatus } from '~/enums';
import useQueryParams from '~/hooks/useQueryParams';
import { RootState } from '~/store';
import { getCardApplication } from '~/store/actions/cardApplicationActions';
import { removeClearedState } from '~/store/slices/cardApplication.slice';
import { ConfirmationPage } from './components/Steps/components/ConfirmationPage/ConfirmationPage';
import { Steps } from './components/Steps/Steps';

export const CardApplication = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const applicationStatus = useSelector(
    (state: RootState) => state.cardApplication.applicationStatus
  );
  const applicationUuid = useSelector(
    (state: RootState) => state.cardApplication.form.applicationUuid
  );
  const cleared = useSelector(
    (state: RootState) => state.cardApplication.cleared
  );

  const queryParams = useQueryParams();
  const applicationUuidParam = queryParams.get('applicationUuid');

  const isFetchingApplication = !!applicationUuidParam && !applicationUuid;

  useEffect(() => {
    if (applicationUuidParam) {
      dispatch(getCardApplication(applicationUuidParam));
    }
  }, []);

  useEffect(() => {
    if (applicationUuid) {
      const url = new URL(window.location.href);
      url.searchParams.set('applicationUuid', applicationUuid);
      history.replace({ search: url.search });
    }
  }, [applicationUuid]);

  useEffect(() => {
    if (cleared) {
      const url = new URL(window.location.href);
      url.searchParams.delete('applicationUuid');
      history.replace({ search: url.search });
      dispatch(removeClearedState());
      document.cookie = `publicToken=; Max-Age=0`;
    }
  }, [cleared]);

  if (isFetchingApplication) {
    return <Loader m="auto" display="flex" h="100vh" />;
  }

  if (applicationStatus === ApplicationStatus.ApplicationFinished) {
    return <ConfirmationPage />;
  }

  return <Steps />;
};
